export const authorizedIds = [
    "5fa0179dc3b7960007de6f30", //irvin
    "5cb99ddb366a9b00069120d7", //mathieu
    "5f902b9803b7640008b2b483", //alexis
    "5cffbe3206a65f000756d19d", //gouff
    "5f71a90e38d24900076b7652", //anthony
    "60508ae028e57100077e0afe", //bastien
    "5f992db019ca3e00088d7283", //luca
]